const initState = {
    dashboard_Data: null,
    dashboard_Data_Indicadores: null,
    dashboard_Error:null,
    dashboard_Fecha:null,
    dashboard_Fecha_Error: null,
    dashboard_Entregas_Excel_Error: null,
    dashboard_Efectividad_Sucursales: null,
    dashboard_Efectividad_Historial: null,
    dashboard_Efectividad_Error: null,
    loading: null
}

const dashboardReducer = (state = initState, action) => {
    switch (action.type) {
        case "DASHBOARD_FECHA_SUCCESS":
            return {
                ...state,
                dashboard_Fecha: action.payload.data,
                dashboard_Fecha_Error: null
            }
        case "DASHBOARD_SUCCESS":
            return {
                ...state,
                dashboard_Data: action.payload.data,
                dashboard_Error: null
            }
        case "DASHBOARD_ERROR":
            return {
                ...state,                
                dashboard_Error: action.payload.error,
                dashboard_Data: null,
            }
        case "DASHBOARD_FECHA_ERROR":
            return {
                ...state,                
                dashboard_Fecha_Error: action.payload.error,
                dashboard_Fecha: null,
            }
        case "DASHBOARD_INDICADORES_SUCCESS":
            return {
                ...state,                
                dashboard_Error: null,
                dashboard_Data_Indicadores: action.payload.data,
            }
        
        case "DASHBOARD_ENTREGAS_EXCEL_ERROR":
            return {
                ...state,
                dashboard_Entregas_Excel_Error: action.payload.error,
            }
        case "DASHBOARD_EFECTIVIDAD_SUCURSALES_SUCCESS":
            return {
                ...state,
                dashboard_Efectividad_Sucursales: action.payload.data,
                dashboard_Efectividad_Error: null,
            }
        case "DASHBOARD_EFECTIVIDAD_HISTORIAL_SUCCESS":
            return {
                ...state,
                dashboard_Efectividad_Historial: action.payload.data,
                dashboard_Efectividad_Error: null,
            }
        case "DASHBOARD_EFECTIVIDAD_ERROR":
            return {
                ...state,
                dashboard_Efectividad_Error: action.payload.error,
            }
        case "DASHBOARD_ENTREGAS_EXCEL_LIMPIAR":
            return {
                ...state,
                dashboard_Entregas_Excel_Error: null,
            }

        default:
            return state;
    }
};


export default dashboardReducer;
